module.exports = __webpack_public_path__ + "static/media/aftertop2.ab707f54.png";